export default "/5253cd0b512a66889ef5afb5e2caf631078665a1/d50cc34e778c6c20c755dccf4a153599.svg";